import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotesBookmarkRoutingModule } from './notes-bookmarks.routing.module';
import { NotesBookmarkComponent } from './notes-bookmark/notes-bookmark.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [NotesBookmarkComponent],
  imports: [
    CommonModule,
    NotesBookmarkRoutingModule,
    SharedModule
  ]
})
export class NotesBookmarksModule { }
